import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { PublicLayout } from './components/SiteChrome';
import { Landing } from './pages/Landing';
import { Branding } from './pages/Branding';
import { Pricing } from './pages/Pricing';
import { Docs } from './pages/Docs';
import { SDKs, SDKGuide } from './pages/SDKs';
import { AuthPage } from './pages/Auth';
import { Dashboard } from './pages/Dashboard';
import { ReportPage } from './pages/Report';
import { AcceptableUsePage, FairUsePage, PrivacyPage, TermsPage } from './pages/Legal';
import { ReferralLanding } from './pages/Referral';
import { metadataEntries, pageMetadata } from '../../server/lib/social-metadata';

export function App() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = pageMetadata(pathname).title;
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.append(canonical);
    }
    canonical.href = pageMetadata(pathname).canonical;
    for (const [attribute, key, value] of metadataEntries(pathname)) {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attribute, key);
        document.head.append(tag);
      }
      tag.content = value;
    }
  }, [pathname]);
  return (
    <Routes>
      <Route path="/sdks" element={<PublicLayout><SDKs /></PublicLayout>} />
      <Route path="/sdks/fivem-redm" element={<PublicLayout><SDKGuide kind="cfx" /></PublicLayout>} />
      <Route path="/sdks/nodejs" element={<PublicLayout><SDKGuide kind="node" /></PublicLayout>} />
      <Route path="/sdks/python" element={<PublicLayout><SDKGuide kind="python" /></PublicLayout>} />
      <Route path="/branding" element={<PublicLayout><Branding /></PublicLayout>} />
      <Route
        path="/"
        element={
          <PublicLayout>
            <Landing />
          </PublicLayout>
        }
      />
      <Route
        path="/fair-use"
        element={
          <PublicLayout>
            <FairUsePage />
          </PublicLayout>
        }
      />
      <Route
        path="/pricing"
        element={
          <PublicLayout>
            <Pricing />
          </PublicLayout>
        }
      />
      <Route
        path="/docs"
        element={
          <PublicLayout>
            <Docs />
          </PublicLayout>
        }
      />
      <Route path="/login" element={<AuthPage mode="login" />} />
      <Route path="/signup" element={<AuthPage mode="signup" />} />
      <Route path="/forgot-password" element={<AuthPage mode="forgot" />} />
      <Route path="/invite/:token" element={<AuthPage mode="invite" />} />
      <Route
        path="/r/:slug"
        element={
          <PublicLayout>
            <ReferralLanding />
          </PublicLayout>
        }
      />
      <Route
        path="/report"
        element={<PublicLayout><ReportPage /></PublicLayout>}
      />
      <Route
        path="/terms"
        element={<PublicLayout><TermsPage /></PublicLayout>}
      />
      <Route
        path="/privacy"
        element={<PublicLayout><PrivacyPage /></PublicLayout>}
      />
      <Route
        path="/acceptable-use"
        element={<PublicLayout><AcceptableUsePage /></PublicLayout>}
      />
      <Route path="/dashboard/people" element={<Navigate to="/dashboard/workspace" replace />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/dashboard/*" element={<Dashboard />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
